function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useEffect, useRef } from 'react';
import { useScrollTo } from '@bydesign-ui/hooks';
import { clamp, classnames, debounce } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls, useDirection } from '@byte-design/config';
import { Search } from '../../../common/icons';
import { useCascader, useCascaderActive, useCascaderItem, useCascaderRoot, useCascaderSearch } from '../../../hooks/cascader';
import { AutoSizedList } from '../../../units/auto-sized-list';
import { useGetTrigger } from '../../../hooks/popper';
import { Empty } from '../../empty';
import { Input } from '../../input';
import { HighlightKeyword } from '../../util/HighlightKeyword';
import { CascaderColumn } from './CascaderColumn';
import { CascaderItem } from './CascaderItem';
export function CascaderSelectPopoverPanel(props) {
  var empty = useLocale('cascader.empty');
  var searchText = useLocale('cascader.search');
  var show = props.show,
      className = props.className,
      renderItem = props.renderItem,
      _props$autoAlign = props.autoAlign,
      autoAlign = _props$autoAlign === void 0 ? true : _props$autoAlign,
      propMaxPopoverWidth = props.maxPopoverWidth,
      triggerId = props.triggerId,
      _props$searchable = props.searchable,
      searchable = _props$searchable === void 0 ? true : _props$searchable,
      _props$searchPlacehol = props.searchPlaceholder,
      searchPlaceholder = _props$searchPlacehol === void 0 ? searchText : _props$searchPlacehol,
      _props$searchDebounce = props.searchDebounceTime,
      searchDebounceTime = _props$searchDebounce === void 0 ? 0 : _props$searchDebounce,
      renderSearchItem = props.renderSearchItem,
      onSearchChange = props.onSearchChange,
      autoFocusSearch = props.autoFocusSearch,
      emptyRender = props.emptyRender,
      emptyContent = props.emptyContent;
  var direction = useDirection();
  var wrapperRef = useRef(null);
  var inputRef = useRef(null);
  var info = useCascaderRoot();
  var activeIds = useCascaderActive();
  var cascader = useCascader();
  var columnWidth = cascader.columnWidth,
      rowHeight = cascader.rowHeight;
  var maxPopoverWidth = propMaxPopoverWidth !== null && propMaxPopoverWidth !== void 0 ? propMaxPopoverWidth : columnWidth * 3;
  var minPopoverWidth = Math.min(columnWidth, maxPopoverWidth);
  var rootId = cascader.getRootId();
  var lastId = activeIds.pop();
  var lastInfo = useCascaderItem(lastId || rootId);

  var _useCascaderSearch = useCascaderSearch(onSearchChange),
      _useCascaderSearch2 = _slicedToArray(_useCascaderSearch, 3),
      query = _useCascaderSearch2[0],
      queryItemIds = _useCascaderSearch2[1],
      onQueryChange = _useCascaderSearch2[2];

  var searching = !!query;
  var cls = classnames(usePrefixCls('cascader-popover-panel'), className);
  var wrapperCls = usePrefixCls('cascader-popover-wrapper');
  var innerCls = usePrefixCls('cascader-popover-panel-inner');
  var searchCls = usePrefixCls('cascader-popover-search-input');
  var searchPopoverCls = usePrefixCls('cascader-search-popover', {
    empty: !queryItemIds.length
  });

  if (lastInfo && !lastInfo.isLeaf && !lastInfo.needLoad && lastId) {
    activeIds.push(lastId);
  }

  var allColumnWidth = activeIds.length * columnWidth;
  var activeTrigger = useGetTrigger(triggerId);
  var activeTriggerWidth = activeTrigger ? activeTrigger.getRect().width : allColumnWidth;
  var rawPanelWidth = query ? columnWidth : clamp(allColumnWidth, minPopoverWidth, maxPopoverWidth);
  var panelWidth = autoAlign ? clamp(rawPanelWidth, Math.min(activeTriggerWidth, maxPopoverWidth), maxPopoverWidth) : rawPanelWidth;
  var finalColumnWidth = allColumnWidth < panelWidth ? Math.floor(panelWidth / activeIds.length) : columnWidth;
  var innerWidth = query ? panelWidth : finalColumnWidth * activeIds.length;
  var columnCls = usePrefixCls('cascader-column', {
    empty: !info.children || !info.children.length,
    rtl: direction === 'rtl'
  });

  var renderColumns = function renderColumns() {
    if (!info.children || !info.children.length) {
      return React.createElement(CascaderColumn, {
        columnTitle: cascader.getColumnTitle(0, rootId),
        className: columnCls,
        parentId: '',
        rowHeight: rowHeight,
        columnWidth: finalColumnWidth
      }, emptyRender ? emptyRender(empty) : React.createElement(Empty, {
        content: emptyContent ? emptyContent(empty) : empty
      }));
    }

    if (activeIds.length) {
      return activeIds.map(function (id, idx) {
        return React.createElement(CascaderColumn, {
          key: id,
          columnTitle: cascader.getColumnTitle(idx, id),
          parentId: id,
          renderItem: renderItem,
          rowHeight: rowHeight,
          columnWidth: finalColumnWidth
        });
      });
    }

    return React.createElement(CascaderColumn, {
      key: info.id,
      columnTitle: cascader.getColumnTitle(0, rootId),
      parentId: info.id,
      rowHeight: rowHeight,
      columnWidth: finalColumnWidth
    });
  };

  var handleClick = useCallback(function () {
    if (!cascader.multiple) {
      onQueryChange('', false);
    }
  }, []);

  var defaultRenderSearchItem = function defaultRenderSearchItem(item) {
    return React.createElement(HighlightKeyword, {
      label: item.search,
      keyword: cascader.query
    });
  };

  var innerRenderSearchItem = function innerRenderSearchItem(_ref) {
    var key = _ref.key,
        index = _ref.index,
        style = _ref.style;
    return React.createElement(CascaderItem, {
      key: key,
      id: queryItemIds[index],
      style: style,
      onClick: handleClick
    }, renderSearchItem || defaultRenderSearchItem);
  };

  var renderSearch = function renderSearch() {
    if (!queryItemIds.length) {
      return React.createElement("div", {
        className: searchPopoverCls,
        style: {
          width: '100%'
        }
      }, emptyRender ? emptyRender(empty) : React.createElement(Empty, {
        content: emptyContent ? emptyContent(empty) : empty
      }));
    }

    var rowCount = queryItemIds.length;
    return React.createElement("div", {
      className: 'byted-cascader-column',
      style: {
        width: "".concat(200, "%")
      }
    }, React.createElement("div", {
      className: 'byted-cascader-column-list'
    }, React.createElement(AutoSizedList, {
      listClsName: innerCls,
      rowHeight: rowHeight,
      rowCount: rowCount,
      rowRenderer: innerRenderSearchItem
    })));
  };

  var scrollPosition = panelWidth < (activeIds.length || 1) * columnWidth ? (activeIds.length - 1) * columnWidth : 0;

  var _useScrollTo = useScrollTo(wrapperRef, 'left', scrollPosition, 150, function () {
    return wrapperRef.current !== null;
  }),
      startScroll = _useScrollTo.startScroll;

  useEffect(function () {
    if (scrollPosition && !searching) {
      startScroll();
    }
  });
  var needDebounce = Boolean(searchDebounceTime !== 0);
  var debouncedRequest = useCallback(debounce(function (query) {
    onQueryChange(query);
  }, searchDebounceTime), [searchDebounceTime]);
  var searchHandlerCallBack = useCallback(function (query) {
    if (!query) {
      debouncedRequest.cancel();
      onQueryChange(query);
    } else {
      debouncedRequest(null, query);
    }
  }, [debouncedRequest]);
  var searchHandler = needDebounce ? searchHandlerCallBack : onQueryChange;
  useEffect(function () {
    var _a, _b;

    if (autoFocusSearch && show) {
      (_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
    }
  }, [show, autoFocusSearch]);
  return React.createElement("div", {
    className: cls,
    style: {
      width: "".concat(panelWidth, "px"),
      overflowX: scrollPosition ? undefined : 'hidden',
      transition: scrollPosition ? undefined : 'ease-in-out width 0.15s'
    }
  }, searchable && React.createElement("div", {
    className: searchCls
  }, React.createElement(Input, {
    outlined: false,
    inputRef: inputRef,
    value: query,
    onValueChange: searchHandler,
    placeholder: searchPlaceholder,
    prefix: React.createElement(Search, null),
    clearable: true
  })), React.createElement("div", {
    ref: wrapperRef,
    className: wrapperCls
  }, React.createElement("div", {
    className: innerCls,
    style: {
      width: "".concat(innerWidth, "px")
    }
  }, searchable && query ? renderSearch() : renderColumns())));
}